<template>
  <v-app>
    <v-content>
      <v-container fluid>
        <v-layout align-center justify-center>
          <v-card style="width: 700px">
            <v-card-title primary-title> </v-card-title>
            <v-flex>
              <v-form ref="form" v-model="form" class="pa-4 pt-6">
                <label style="font-size: large">{{
                  $t("surveysPage.editConstraintHeading", {
                    name: constraint.constraint_name,
                  })
                }}</label>
                <v-text-field
                  outline
                  v-model="constraint.customer_app_message"
                  :label="$t('surveysPage.customerAppMessageField')"
                  type="text"
                  :rules="[rules.required]"
                  style="margin-top: 15px"
                ></v-text-field>
                <v-flex xs12>
                  <v-select
                    :label="$t('surveysPage.canDriverEdit')"
                    :items="[
                      { text: $t('surveysPage.optionYes'), value: 1 },
                      { text: $t('surveysPage.optionNo'), value: 0 },
                    ]"
                    v-model="constraint.driver_on_off"
                  ></v-select>
                </v-flex>

                <v-flex xs12>
                  <v-select
                    :label="$t('surveysPage.showInCustomerApp')"
                    :items="[
                      { text: $t('surveysPage.optionYes'), value: 1 },
                      { text: $t('surveysPage.optionNo'), value: 0 },
                    ]"
                    v-model="constraint.customer_on_off"
                  ></v-select>
                </v-flex>
                <v-flex xs12>
                  <v-select
                    :label="$t('surveysPage.strikeThrough')"
                    :items="[
                      { text: $t('surveysPage.optionYes'), value: true },
                      { text: $t('surveysPage.optionNo'), value: false },
                    ]"
                    v-model="constraint.strike_through"
                  ></v-select>
                </v-flex>
                <v-btn :loading="loading" block @click="save" color="secondary"
                  >{{ $t("surveysPage.save") }}
                </v-btn>
              </v-form>
            </v-flex>
          </v-card>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
export default {
  name: "Edit_Constraint",
  title() {
    return this.$t("surveysPage.editConstraintTitle");
  },
  components: {},

  data() {
    return {
      loading: false,
      form: false,
      isLoading: false,
      error: false,
      constraint: {
        constraint_name: "",
        customer_app_message: "",
        driver_on_off: false,
        customer_on_off: false,
        strike_through: false
      },
    };
  },
  computed: {
    rules() {
      return {
        required: (v) => !!v || this.$t("surveysPage.ruleRequired"),
      };
    },
  },
  watch: {},
  created() {
    this.axios
      .get(`dynamic_constraints/${this.$route.params.id}`)
      .then(({ data }) => {
        this.constraint.constraint_name = data.data.constraint_name;
        this.constraint.customer_app_message = data.data.customer_app_message;
        this.constraint.driver_on_off = data.data.driver_on_off;
        this.constraint.customer_on_off = data.data.customer_on_off;
        this.constraint.strike_through = data.data.strike_through;
      });
  },
  methods: {
    save() {
        if (!this.$refs.form.validate()) {
          window.getApp.$emit(
            "SHOW_TOAST",
            this.$t("surveysPage.toastFillAllData"),
            "red"
          );
          return;
        }
        this.loading = true;
        this.axios
          .put(`dynamic_constraints/${this.$route.params.id}`, {
            ...this.constraint,
          })
          .then(() => {
            window.getApp.$emit(
              "SHOW_TOAST",
              this.$t("surveysPage.toastConstraintSaved")
            );
            this.$router.push(`/constraints`);
          })
          .catch(({ response }) => {
            window.getApp.$emit(
              "SHOW_TOAST",
              this.$t("surveysPage.toastFailedSaveConstraint"),
              "red"
            );
            console.log(response);
          })
          .finally(() => (this.loading = false));
    },
  },
};
</script>
